import { FORM_TOKEN_NODE_KEY_SEPARATOR } from '../../constants';

// Instances with different subUrl share one object store; this prefix range
// (￿ = highest char) scopes bulk getAll/delete to the given storage key
export const getFormTokenMetaKeyRange = (storageKey: string): IDBKeyRange =>
  IDBKeyRange.bound(
    `${storageKey}${FORM_TOKEN_NODE_KEY_SEPARATOR}`,
    `${storageKey}${FORM_TOKEN_NODE_KEY_SEPARATOR}￿`
  );
